(function () {
  let warnedDisabledEvent = false;

  function centsToFloat(cents) {
    if (cents == null || cents === '') return 0;
    const n = typeof cents === 'number' ? cents : parseFloat(String(cents));
    return Number.isFinite(n) ? n / 100 : 0;
  }

  function getListPriceFromLine(line, salePriceFloat) {
    const compareRaw = line.compare_at_price;
    if (compareRaw != null && compareRaw !== '') {
      const fromLine = centsToFloat(compareRaw);
      if (fromLine > salePriceFloat) return fromLine;
    }
    const vid = line.variant_id || line.id;
    const map = typeof window.WOOWUP_VARIANT_PRICE_MAP === 'object' && window.WOOWUP_VARIANT_PRICE_MAP
      ? window.WOOWUP_VARIANT_PRICE_MAP[String(vid)] || window.WOOWUP_VARIANT_PRICE_MAP[vid]
      : null;
    if (!map || map.compare_at == null || map.compare_at === '') return null;
    const fromMap = centsToFloat(map.compare_at);
    return fromMap > salePriceFloat ? fromMap : null;
  }

  function buildPayload(line) {
    if (!line) return null;
    const sku = (line.sku && String(line.sku).trim()) || String(line.variant_id || line.id || '');
    if (!sku) return null;
    const sale = centsToFloat(line.price != null ? line.price : line.original_price);
    const list = getListPriceFromLine(line, sale);
    const payload = { sku };
    if (list != null && list > sale) {
      payload.price = list;
      payload.offer_price = sale;
    } else {
      payload.price = sale;
    }
    return payload;
  }

  function trackLineItem(line) {
    const key = typeof window.WOOWUP_PUBLIC_KEY === 'string' ? window.WOOWUP_PUBLIC_KEY.trim() : '';
    if (!key || typeof WU === 'undefined' || typeof WU.track !== 'function') return;
    const eventName = typeof window.WOOWUP_ADD_TO_CART_EVENT === 'string'
      ? window.WOOWUP_ADD_TO_CART_EVENT.trim()
      : '';
    if (!eventName) {
      if (!warnedDisabledEvent) {
        warnedDisabledEvent = true;
        console.info('[WoowUp] add_to_cart deshabilitado: define window.WOOWUP_ADD_TO_CART_EVENT con un evento permitido.');
      }
      return;
    }
    const payload = buildPayload(line);
    if (!payload) return;
    WU.track(key, eventName, payload, function () {});
  }

  function trackFromCartAddResponse(data) {
    if (!data || data.status) return;
    if (data.items && Array.isArray(data.items)) {
      data.items.forEach(trackLineItem);
    } else {
      trackLineItem(data);
    }
  }

  window.woowUpTrackAddToCartFromCartAddResponse = trackFromCartAddResponse;

  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source === 'cart-items') return;
    if (event.source !== 'product-form') return;
    const data = event.cartData;
    if (!data || data.status) return;
    trackFromCartAddResponse(data);
  });
})();
